function getVisibleImage(images) {
    if (!images.length)
        return undefined;
    const [image] = images.filter((img) => getComputedStyle(img).display === 'block');
    return image;
}
export function getImageAltTextAndUrl(element) {
    if (!element) {
        return undefined;
    }
    const images = Array.from(element.querySelectorAll('img'));
    const visibleImage = getVisibleImage(images);
    if (visibleImage) {
        const { currentSrc, src, alt } = visibleImage;
        return {
            altText: alt,
            imageUrl: currentSrc || src,
        };
    }
    return undefined;
}
//# sourceMappingURL=get-image-alt-text-and-url.js.map